var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ids-root",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"information"},[_vm._m(0),_c('p',[_vm._v(_vm._s(_vm.$t('加载中...')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vbox"},[_c('div',{staticClass:"loading",attrs:{"data-loader":"circle"}})])
}]

export { render, staticRenderFns }